import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { SoaService } from '../../form-wrappers/soa-form/services/soa.service';
import { SoaDashboardParams } from '../interfaces/SOA/soa-dashboard-params.interface';
import { SoaDashboardResponse } from '../interfaces/SOA/soa-dashboard-response.interface';

@Component({
    selector: 'app-soa-dashboard',
    templateUrl: './soa-dashboard.component.html',
    styleUrls: ['./soa-dashboard.component.scss'],
    standalone: false
})
export class SoaDashboardComponent implements OnInit {

  @Input() agentEsoaLink: string;

  searchParams: SoaDashboardParams;

  soasPerPage = 10;
  currentPage = 1;
  totalSoas = 0;
  totalPages = 0;
  firstSoaNo = 1;
  lastSoaNo = this.soasPerPage;

  appointments: any = [];

  isLoading: boolean = false;

  searchForm: UntypedFormGroup;
  searchFilters = [
    { label: 'Email', value: 'emailId' },
    { label: 'SOA ID', value: 'soaTokenId' },
    { label: 'Last Name', value: 'lastName' }
  ]

  sortOptions = [
    'Email Sent Date',
    'Last Name (Ascending)',
    'SOA ID'
  ];

  sortOption = 'Email Sent Date';

  constructor(
    private soaService: SoaService,
    private formBuilder: UntypedFormBuilder
  ) {}

  ngOnInit(): void {
    this.searchForm = this.formBuilder.group({
      filterType: this.formBuilder.control('', []),
      filterValue: this.formBuilder.control('', [])
    })
    this.loadDashboard();
  }

  loadDashboard() {
    this.search();
  }

  async search() {
    this.resetInitialNumbers();
    try {
      this.searchParams = {
        emailId: null,
        soaTokenId: null,
        lastName: null,
        pageNumber: this.currentPage - 1,
        countPerPage: this.soasPerPage,
      };

      const formValues = this.searchForm.value;

      if (formValues.filterType && formValues.filterValue) {
        this.searchParams[formValues.filterType] = formValues.filterValue;
      }

      this.isLoading = true;
      const response: SoaDashboardResponse = await this.soaService.getAppointments(this.searchParams);
      this.appointments = response.scopeOfAppointments;
      this.isLoading = false;

      return response;
    } catch (e) {
      console.log(e);
    }
  }

  async reset() {
    this.resetInitialNumbers();
    this.searchForm.reset();
    this.searchForm["filterType"] = '';
    this.searchForm["filterValue"] = '';
    
    try {
      this.searchParams = {
        emailId: null,
        soaTokenId: null,
        lastName: null,
        pageNumber: this.currentPage - 1,
        countPerPage: this.soasPerPage,
      };

      this.isLoading = true;
      const response: SoaDashboardResponse = await this.soaService.getAppointments(this.searchParams);
      this.appointments = response.scopeOfAppointments;
      this.isLoading = false;

      return response;
    } catch (e) {
      console.log(e);
    }
  }

  async sortAppointments($event: any) {
    this.resetInitialNumbers();

    this.searchParams = {
      emailId: null,
      soaTokenId: null,
      lastName: null,
      pageNumber: this.currentPage - 1,
      countPerPage: this.soasPerPage,
    };

    const formValues = this.searchForm.value;

    if (formValues.filterType && formValues.filterValue) {
      this.searchParams[formValues.filterType] = formValues.filterValue;
    }

    this.isLoading = true;
    const response: SoaDashboardResponse = await this.soaService.getAppointments(this.searchParams);
    this.isLoading = false;

    const emailSentDate = 'Email Sent Date';
    const lastNameAsc = 'Last Name (Ascending)';
    const soaId = 'SOA ID';

    if ($event) {
      switch ($event.value) {
        case soaId: {
          this.appointments = response.scopeOfAppointments.sort((a, b) => (a.soaTokenId < b.soaTokenId) ? -1 : 1);
          break;
        }
        case lastNameAsc: {
          this.appointments = response.scopeOfAppointments.sort((a, b) => (a.lastName.toLowerCase() < b.lastName.toLowerCase()) ? -1 : 1);
          break;
        }
        case emailSentDate: {
          this.appointments = response.scopeOfAppointments.sort((a, b) => (a.emailSent.actionDate < b.emailSent.actionDate) ? -1 : 1);
          break;
        }
      }
    }
  }

  resetInitialNumbers() {
    this.soasPerPage = 10;
    this.currentPage = 1;
    this.totalSoas = 0;
    this.totalPages = 0;
    this.firstSoaNo = 1;
  }


}
